import actionCreatorFactory from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

/** eラーニングSCORM情報設定アクションクリエータ */
export const setScormParams = actionCreator<{
	startTime: string;
	location: string;
}>('SET_SCORM_PARAMS');

/** eラーニングSCORM情報初期化アクションクリエータ */
export const clearScormParams = actionCreator('CLEAR_SCORM_PARAMS');



// WEBPACK FOOTER //
// ./src/actions/scorm.ts